import { Form, Layout, Core } from 'connex-cds';
import React from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import { useCompanySetup } from '../../../MasterDataProvider';
import Comments from '../../../ticket-details/comments/Comments';
import DriverInstructions from '../../../ticket-details/driver-instructions/DriverInstructions';
import DriverCommentInternal from '../../../ticket-details/driver-comment-internal/DriverCommentInternal';
import Attachments from '../../../ticket-details/attchments/Attachments';
import { LoadingUnloadingPoints } from '../../../ticket-details/logistical-info/loading-unloading-points/LoadingUnloadingPoints';
import { MaterialSummary } from '../../../ticket-details/logistical-info/material-summary/MaterialSummary';
import StatusTimes from '../../../ticket-details/logistical-info/StatusTimes';
import UnloadingMethodForm from '../../../UnloadingMethodForm';
import { TicketDetailActions } from './TicketDetailActions';

const { Column, Row, Container } = Layout;

const Styled = styled.div`
  .driver-instructions-buttons {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const TicketDetailDesktop = ({
  activeFormsAndWaivers,
  isLoading,
  attachments = [],
  toggleEarlyAcceptance,
  unloadingMethodEnabled,
}) => {
  const companySetup = useCompanySetup();
  const { values } = Form.useFormContext();

  return (
    <Styled className={cn('ticket-detail-desktop')}>
      <Core.Spinner spin={isLoading}>
        <Column>
          <Row flex={1} className="content-row">
            <Column flex={1} className="">
              <MaterialSummary />
              <LoadingUnloadingPoints data={values} />
              {companySetup?.data?.isDriverCommentEnabled && (
                <Container style={{ padding: '15px' }}>
                  <Comments />
                </Container>
              )}
              {unloadingMethodEnabled && (
                <Container style={{ padding: '10px', paddingBottom: '5px' }}>
                  <UnloadingMethodForm />
                </Container>
              )}
              {companySetup?.data?.isDriverCommentEnabled && (
                <Container style={{ padding: '15px' }}>
                  <DriverCommentInternal />
                </Container>
              )}
            </Column>
            <Column flex={1}>
              <StatusTimes />
              <Container style={{ padding: '10px', flex: '1' }}>
                <DriverInstructions data={values} />
                <TicketDetailActions
                  activeFormsAndWaivers={activeFormsAndWaivers}
                  toggleEarlyAcceptance={toggleEarlyAcceptance}
                />
              </Container>
              {attachments?.length > 0 && <Attachments />}
            </Column>
          </Row>
        </Column>
      </Core.Spinner>
    </Styled>
  );
};
